const ucFirst = (string) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : ''

const formatDate = (month, day, year) => {
  let date = ''
  if (month !== '') date += month
  if (day !== '') {
    if (date.trim() !== '') date += ' '
    date += day
  }
  if (year) {
    if (date.trim() !== '') date += ', '
    date += year
  }
  return date
}

const getAccessedDate = (data) => {
  if (!data) return ''
  const day = data.dayaccessed
  const month = ucFirst(data.monthaccessed)
  const year = data.yearaccessed
  if (!day || !month || !year) return ''

  return formatDate(month, day, year)
}

const getPublishedDate = (data) => {
  if (!data) return ''
  const { day } = data
  const month = ucFirst(data.month)
  const { year } = data
  if (!day || !month || !year) return ''

  return formatDate(month, day, year)
}

export const getWebsiteFields = (citation, style) => {
  const fields = [
    {
      label: 'Article title',
      value: citation?.['article-journal']?.title || citation?.website?.title,
    },
  ]
  if (style !== 'apa') {
    fields.push({
      label: 'Publisher / Sponsor',
      value: citation.other && citation.other.sponsor,
    })
  }
  if (citation.pubonline) {
    fields.push(
      { label: 'URL', value: citation.pubonline.url },
      { label: 'Website title', value: citation.pubonline.title },
      { label: 'Date accessed', value: getAccessedDate(citation.pubonline) },
      { label: 'Date published', value: getPublishedDate(citation.pubonline) }
    )
  } else {
    // console.error(new Error('no pubonline'), null, { citation })
  }
  return fields
}

export const getBookFields = (citation) => {
  return [
    { label: 'Book title', value: citation.pubnonperiodical.title },
    { label: 'Book publisher', value: citation.pubnonperiodical.publisher },
    { label: 'Publication year', value: citation.pubnonperiodical.year },
  ]
}

export const getJournalFields = (citation) => {
  return [
    { label: 'Journal title', value: citation.pubjournal.title },
    { label: 'Publication year', value: citation.pubjournal.year },
    { label: 'Publication month', value: citation.pubjournal.month },
    { label: 'Publication day', value: citation.pubjournal.day },
    { label: 'Article title', value: citation.journal.title },
  ]
}
